/* eslint-disable max-len */
import React from 'react';

interface ExlamationCircleProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const ExlamationCircle: React.FC<ExlamationCircleProps> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.0005 1.25146C14.832 1.2517 18.7485 5.16892 18.7485 10.0005C18.7482 14.8317 14.8318 18.7483 10.0005 18.7485C5.16912 18.7484 1.25185 14.8318 1.25146 10.0005C1.25146 5.16885 5.16888 1.25159 10.0005 1.25146ZM10.0005 2.75146C5.99731 2.75159 2.75146 5.99728 2.75146 10.0005C2.75185 14.0034 5.99755 17.2484 10.0005 17.2485C14.0033 17.2483 17.2482 14.0033 17.2485 10.0005C17.2485 5.99734 14.0036 2.7517 10.0005 2.75146ZM10.0024 12.4009C10.4441 12.4009 10.8022 12.759 10.8022 13.2007C10.8022 13.6424 10.4441 14.0005 10.0024 14.0005C9.56081 14.0004 9.20264 13.6423 9.20264 13.2007C9.20264 12.759 9.56081 12.4009 10.0024 12.4009ZM10.0015 5.25146C10.4155 5.25173 10.7515 5.58741 10.7515 6.00146V10.8003C10.7512 11.2141 10.4153 11.55 10.0015 11.5503C9.58743 11.5503 9.25175 11.2143 9.25146 10.8003V6.00146C9.25146 5.58725 9.58725 5.25146 10.0015 5.25146Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default ExlamationCircle;
